import { TabItem } from 'component/Tabs/Tabs.types'
import { useState } from 'react'
import { useTranslation } from 'react-i18n-lite'
import { FilterableMapProps } from '../../FilterableMap.types'
import getTabsItems from '../../utils/getTabItems'

type AvailableTabsProps = {
  availableTabs: FilterableMapProps['props']['availableTabs']
  country: string
}

const useFilterableMapTabs = ({
  availableTabs,
  country
}: AvailableTabsProps) => {
  const { t } = useTranslation()

  const allTabs = [
    {
      uuid: 'federal',
      des: t('filterable-map.federal-domain')
    },
    {
      uuid: 'state',
      des: t('filterable-map.state-domain')
    }
  ]

  const tabsItems = getTabsItems(allTabs, availableTabs)

  const [selectedTab, setSelectedTab] = useState<TabItem>(
    tabsItems?.[country]?.[0]
  )

  return {
    tabsItems,
    selectedTab,
    setSelectedTab
  }
}

export default useFilterableMapTabs
